import { compact, find } from 'lodash'

import { t } from 'translations'

type AvailableSettings = {
  key: string
  main: string
  modules: string
  values: string | Record<string, unknown>[]
}

const parseSettingInfo = (
  settings: Record<string, unknown>,
  availableSettings: AvailableSettings[],
  footerMap = {},
  onlyMap: boolean
): Record<string, unknown> => {
  let parsedSettingInfo = availableSettings.reduce((acc, { key, main, modules, values, ...rest }) => {
    // Adds every setting into a sub-array by module
    if (!acc[modules]) acc[modules] = []

    acc[modules].push({
      ...rest,
      // Translate keys for values
      values: Array.isArray(values) ? values.map(({ name, ...option }) => ({ name: t(name as string), ...option })) : values,
      key,
      main,
      modules,
      value: key,
      label: t(`administration.applicationSettings.form.${key.toUpperCase()}.LABEL`),
      description: t(`administration.applicationSettings.form.${key.toUpperCase()}.DESCRIPTION`)
    })

    // Set if the module is currently activated
    if (main && settings[key]) acc[`${modules}Activated`] = true

    return acc
  }, {})

  if (onlyMap) return parsedSettingInfo

  parsedSettingInfo = compact(
    Object.keys(parsedSettingInfo).map(key => {
      const mainSettingOfModule = find(parsedSettingInfo[key], settingInfo => settingInfo.main)
      // Only there to indicate the the module is active, we want to remove it now.
      if (key.includes('Activated') || key === 'ignored') return null

      const { img, modules, inputGroup, isAlpha, isBeta, isDisabled, isIntegration, isMeringo, footer } = mainSettingOfModule || parsedSettingInfo[key][0]

      // Return an object containing the main module info and it's settings
      return {
        img,
        inputGroup,
        isAlpha,
        isBeta,
        isDisabled,
        isIntegration,
        isMeringo,
        modules,
        title: key,
        sortKey: t(`administration.applicationSettings.${key.toUpperCase()}.TITLE`),
        isActive: parsedSettingInfo[`${key}Activated`] || !mainSettingOfModule,
        settings: parsedSettingInfo[key],
        Footer: footerMap[footer]
      }
    })
  )

  return parsedSettingInfo
}

export default parseSettingInfo
